<template>
  <div class="modal-body-message-template-quote">
    <div
      class="modal-body-message-template-quote-tabs btn-group d-flex mb-3"
      data-toggle="btns"
      role="group"
    >
      <a
        v-for="index in 5"
        :key="`title_${index}`"
        class="btn btn-lg btn-info modal-tab-btn w-100"
        role="button"
        data-toggle="tab"
        :href="'#tab-message-description' + index"
        :class="{ active: index === selected_tab }"
        @click="selected_tab = index"
        >{{ titles[index - 1] }}
      </a>
    </div>
    <div class="modal-body-message-template-quote-tab-content tab-content">
      <div
        v-for="index in 5"
        :id="'tab-message-description' + index"
        :key="`message_${index}`"
        class="tab-pane"
        role="tabpanel"
        :class="{ active: index === selected_tab }"
      >
        <label
          v-for="index2 in description[index - 1].length"
          :key="`description_${index2}`"
          class="modal-template-item"
        >
          <input
            id="radio01"
            type="radio"
            class="modal-template-radio-input"
            name="radio01"
            @click="quote(index, index2)"
          />
          <p class="modal-template-radio-parts d-flex align-items-center">
            <i class="fa fa-check-circle fa-lg" />
            <span v-html="description[index - 1][index2 - 1].replace(/\n/g, '<br/>')" />
          </p>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import { eventBus } from '@/utility/event-bus';

export default {
  props: {
    tab_titles: Array,
    tab_panes: Array,
  },
  data() {
    return {
      selected_tab: 1,
      titles: this.tab_titles,
      description: this.tab_panes,
    };
  },
  methods: {
    quote(index, index2) {
      eventBus.quoteMessage(this.description[index - 1][index2 - 1]);
    },
  },
};
</script>

<style lang="sass" scoped>
.modal-tab-btn
    font-size: 16px
    color: #002832
    background-color: #FFF
    border-color: rgba(0, 0, 0, 0.06)
    &.active
        background-color: #28c3cd
        color: #FFF

.modal-template-item
    display: block
    margin-bottom: 10px
    padding: 4px 16px
    font-size: 16px
    background-color: rgba(0, 0, 0, 0.06)
    border-radius: 6px
    border-color: rgba(0, 0, 0, 0.06)
    span
        padding-right: 10px
    .modal-template-radio-input
        display: none
    .modal-template-radio-parts
        margin: 0
        color: #002832
        i
            margin-right: 10px
            color: #FFF
        a
            display: none
    .modal-template-radio-input:checked
        + .modal-template-radio-parts
            i
                color: #28c3cd
            a
                display: inline
</style>
